import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'KiteDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix } = __props;

const dimensions = computed(() => store.getters.getMeasurements( 'kite', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const dimensionMaxLabel = computed(() => store.getters.getMaxLabelForDimension);
const isDimensionValid = computed(() => store.getters.isShapeValid( isCutout ) );

const width = computed({
	get: () => dimensions.value.width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "width",
			value: value,
		});
	},
});

const heightTop = computed({
	get: () => dimensions.value.height_top,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height_top",
			value: value,
		});
	},
});

const heightBottom = computed({
	get: () => dimensions.value.height_bottom,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "height_bottom",
			value: value,
		});
	},
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "kite-height_top",
        id: `${_ctx.prefix}measurements-kite-height_top`,
        name: `${_ctx.prefix}measurements[dimensions][height_top]`,
        unit: "cm",
        label: dimensionLabel.value('height_top', 'kite'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('height_top'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}kite-height_top`),
        onBlur: () => _unref(addSizeToDataLayer)('height_top', +heightTop.value, 'kite'),
        modelValue: heightTop.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((heightTop).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "kite-height_bottom",
        id: `${_ctx.prefix}measurements-kite-height_bottom`,
        name: `${_ctx.prefix}measurements[dimensions][height_bottom]`,
        unit: "cm",
        label: dimensionLabel.value('height_bottom', 'kite'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('height_bottom'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}kite-height_bottom`),
        onBlur: () => _unref(addSizeToDataLayer)('height_bottom', +heightBottom.value, 'kite'),
        modelValue: heightBottom.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((heightBottom).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "kite-width",
        id: `${_ctx.prefix}measurements-kite-width`,
        name: `${_ctx.prefix}measurements[dimensions][width]`,
        unit: "cm",
        label: dimensionLabel.value('width', 'kite'),
        instructions: _ctx.isCutout ? '' : dimensionMaxLabel.value('width'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}kite-width`),
        onBlur: () => _unref(addSizeToDataLayer)('width', +width.value, 'kite'),
        modelValue: width.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((width).value = $event))
      }, null, 8, ["id", "name", "label", "instructions", "invalid", "onBlur", "modelValue"])
    ]),
    _: 1
  }))
}
}

})